export * from './DailyAverages';
export * from './DailyAverages.type';
